import o from "./Layout.vue2.js";
import "./Layout.vue3.js";
import t from "../_virtual/_plugin-vue_export-helper.js";
const p = /* @__PURE__ */ t(o, [["__scopeId", "data-v-9310778b"]]);
export {
  p as default
};
